import { render, staticRenderFns } from "./certificado_segunda_via.vue?vue&type=template&id=1fceca64&"
import script from "./certificado_segunda_via.vue?vue&type=script&lang=js&"
export * from "./certificado_segunda_via.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports